import {QUESTS} from '../../configs/quests';
import {getFactionConfig} from '../factions/getFactionConfig';
import {getChestDisplayName} from '../inventory/getChestDisplayName';

export const ONLINE_MATCH_QUEST_ID = 'online_match_not_last';

/**
 * Что игрок получит за задание «сыграть обычный сетевой матч» — для
 * приглашения в первый сетевой матч после обучения (TutorialFinishPromoModal):
 * награда там названа по имени, и она должна совпасть с тем, что выдаст
 * сервер. Правило то же, что у самой выдачи (resolveMatchQuestRewards): за
 * уже выполненное задание награды нет; иначе фракция, а если она у игрока
 * уже открыта — запасная награда (rewardIfFactionOwned).
 *
 * @param {Array<{id: string, isAvailable: boolean}>} availableFactions - фракции из профиля
 * @param {string[]} [completedQuests] - id выполненных заданий из профиля
 * @returns {{type: 'faction'|'chest', name: string}|null} null — награды не будет
 */
export const getOnlineMatchQuestReward = (availableFactions, completedQuests = []) => {
  const quest = QUESTS.find((item) => item.id === ONLINE_MATCH_QUEST_ID);
  if (!quest?.reward || (completedQuests || []).includes(quest.id)) {
    return null;
  }

  const isRewardFactionOwned = quest.reward.type === 'faction'
    && (availableFactions || []).some((faction) => faction.id === quest.reward.factionId && faction.isAvailable);
  const reward = isRewardFactionOwned ? quest.rewardIfFactionOwned : quest.reward;
  if (!reward) {
    return null;
  }

  if (reward.type === 'faction') {
    return {type: 'faction', name: getFactionConfig(reward.factionId)?.name || reward.factionId};
  }
  if (reward.type === 'chest') {
    return {type: 'chest', name: getChestDisplayName(reward.chestId)};
  }
  return null;
};
